import BaseService from '../../middleware/BaseService';

class DeleteVideoService extends BaseService {
  prefix = '/medias';
}

export default new DeleteVideoService();
